import { ReactNode } from "react";
import "./simple-header.scss";
import classNames from "classnames";

export const defaultSimpleHeaderStyle = {
  background: "bg-gradient-to-r from-green-400 to-indigo-400",
};
export interface SimpleHeaderProps {
  logo: string;
  title: string;
  children: ReactNode;
  style?: typeof defaultSimpleHeaderStyle;
}

export function SimpleHeader({
  logo,
  title,
  children,
  style = defaultSimpleHeaderStyle,
}: SimpleHeaderProps) {
  return (
    <header
      id="SimpleHeader"
      className={classNames(
        "p-4 flex w-full justify-between sticky top-0 z-10",
        style.background
      )}
    >
      <div className="flex items-center gap-2">
        <img src={logo} width="30px" />
        <h2>{title}</h2>
      </div>
      <div className="flex items-center gap-4">{children}</div>
    </header>
  );
}

export default SimpleHeader;
